import axios from '../axios';
// 家庭情况 列表
export const getBaseEmployeeFamilyPage = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeFamilyPage',
        method: 'post',
        data
    })
};
// 家庭情况 保存
export const saveBaseEmployeeFamily = data => {
    return axios({
        url: '/api/sys/base/saveBaseEmployeeFamily',
        method: 'post',
        data
    })
};
// 家庭情况 修改
export const updateBaseEmployeeFamily = data => {
    return axios({
        url: '/api/sys/base/updateBaseEmployeeFamily',
        method: 'post',
        data
    })
};
// 家庭情况 删除
export const deleteBaseEmployeeFamilys = data => {
    return axios({
        url: '/api/sys/base/deleteBaseEmployeeFamilys',
        method: 'post',
        data
    })
};


// WEBPACK FOOTER //
// ./src/api/moudules/family.js